import React from "react";
import { ToolsIAForm } from "../../components";

const NewToolsIA = () => {
  return <ToolsIAForm></ToolsIAForm>;
};

export default NewToolsIA;
